import {formatoFechaExportacion} from "../../Utilidades/formatoFechaExportacion";

export const adaptador_reservas_acompanantes_exportacion = (reservas) => {


    let arr = []
    for (let i = 0; i < reservas.length; i++) {
        let reserva = reservas[i]
        let acompas = reserva.acompanantes ?  reserva.acompanantes : []


        for (let j = 0 ; j < acompas.length;j++){
            let acompa = acompas[j]
            let obj = {
                TipoID: acompa.tipoCc,
                NumeroID: acompa.cc,
                Nombres: acompa.nombres ? acompa.nombres.toUpperCase() : '',
                Apellidos: acompa.apellidos ? acompa.apellidos.toUpperCase() : '',
                CiudadResidencia: reserva.ciudad,
                CiudadProcedencia: reserva.ciudadProcendencia,
                NumHabitacion: reserva.numero,
                CheckIn: reserva.fechaCheckIn ? formatoFechaExportacion(reserva.fechaCheckIn) : '',
                CheckOut: reserva.fechaCheckOut ? formatoFechaExportacion(reserva.fechaCheckOut) : '',
                NumeroIDPrincipal: reserva.cc

            }
            arr.push(obj)
        }


    }

    return arr

}